"use client";
import { fetchShopifyArticleByHandle } from "@/shopify/api/shopify-blogs";
import Image from "next/image";
import { useEffect, useState } from "react";

type Props = {
  params: {
    category: string;
    articleHandle: string;
  };
};

const BlogDetailPage = ({ params }: Props) => {
  const rawBlogHandle = params.category;
  const rawArticleHandle = params.articleHandle;
  const blogHandle = decodeURIComponent(rawBlogHandle);
  const articleHandle = decodeURIComponent(rawArticleHandle);
  const [article, setArticle] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!blogHandle || !articleHandle) return;
    fetchShopifyArticleByHandle(blogHandle, articleHandle)
      .then(setArticle)
      .catch(() => setError("Failed to load article. Please try again later."))
      .finally(() => setIsLoading(false));
  }, [blogHandle, articleHandle]);

  if (isLoading) return <p className="p-6 text-gray-600">Loading article...</p>;
  if (error) return <p className="p-6 text-red-600">{error}</p>;
  if (!article) return <p className="p-6 text-gray-600">Article not found.</p>;

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <p className="text-sm text-gray-500 mb-6 text-center">
        {new Date(article.publishedAt).toLocaleDateString()}
      </p>
      <h1 className="text-3xl font-bold mb-4 text-center">{article.title}</h1>
      {article.image?.url && (
        <Image
          src={article.image.url}
          alt={article.image.altText || article.title}
          width={800}
          height={500}
          className="rounded-lg w-full max-w-2xl h-auto mb-6 mx-auto"
        />
      )}
      <div
        className="prose max-w-none"
        // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
        dangerouslySetInnerHTML={{ __html: article.contentHtml }}
      />
    </div>
  );
};

export default BlogDetailPage;
